import { combineReducers } from 'redux'
import { reducer as modalReducer } from 'redux-saga-modal'
import user from '@/models/user/reducer'
import orders from '@/models/orders/reducer'
import messages from '@/models/messages/reducer'
import tenants from '@/models/tenants/reducer'
import employee from '@/models/employee/reducer'
import managers from '@/models/managers/reducer'
import mgroups from '@/models/mgroups/reducer'
import notifies from '@/models/notifies/reducer'
import productCategory from '@/models/productCategory/reducer'
import referrals from '@/models/referrals/reducer'
import members from '@/models/members/reducer'
import workers from '@/models/workers/reducer'
import products from '@/models/products/reducer'
import productsPending from '@/models/productsPending/reducer'
import configure from '@/models/configure/reducer'
import conversations from '@/models/conversations/reducer'
import globalSearch from '@/models/globalSearch/reducer'
import coupons from '@/models/coupons/reducer'
import cashCoupon from '@/models/cashCoupon/reducer'
import bonusCoupon from '@/models/bonusCoupon/reducer'
import referralRule from '@/models/referralRule/reducer'
import taskHall from '@/models/taskHall/reducer'
import banner from '@/models/banner/reducer'
// 通过model更新 与 通过ajax更新 策略
// 表单类的需要model更新， 视图类无需
// 比如 工单列表（更新表单后无需更新列表，这种的无需更新）
// 或者 ajax 成功后再调用 action.updated

export default combineReducers({
  user,
  orders,
  messages,
  tenants,
  employee,
  managers,
  mgroups,
  notifies,
  productCategory,
  referrals,
  members,
  workers,
  products,
  productsPending,
  configure,
  conversations,
  globalSearch,
  coupons,
  cashCoupon,
  bonusCoupon,
  referralRule,
  taskHall,
  banner,
  modals: modalReducer,
})
